/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/svenskdam/components/standalone/Button/theme';

export const ButtonTheme = theme;
